import React from 'react';
import PropTypes from 'prop-types';
import MarketoProfileForm from './MarketoProfileForm';

const Profile = ({ profileImg, profileHtml }) => (
  <React.Fragment>
    <div className="profile">
      <img src={profileImg} alt="profile_avator" className="profile_avatar" />
      <div dangerouslySetInnerHTML={{ __html: profileHtml }} />
    </div>
    <MarketoProfileForm />
  </React.Fragment>
);

Profile.propTypes = {
  profileHtml: PropTypes.string.isRequired,
  profileImg: PropTypes.string.isRequired
};

export default Profile;
